var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlcssLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 100,
    viewBox: "0 0 149 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "html&css"
  }, /*#__PURE__*/React.createElement("g", {
    id: "html-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4091 0.435791L148.327 24.164L118.076 89.6855L88.5493 87.735C88.5239 87.7325 88.4996 87.7302 88.4764 87.7279C87.9933 87.6811 87.9598 87.6778 87.5315 87.3741C87.4156 87.2919 86.9968 86.9893 86.3412 86.5156C82.4665 83.7157 70.318 74.937 63.4988 70.3331L81.4091 0.435791ZM88.8745 18.5597L130.857 33.4462L127.352 41.7165L95.0378 30.2584L92.8493 38.8537L123.465 49.8514L112.178 74.8151L93.9847 73.6176C93.0048 73.5541 92.8775 73.509 92.2037 72.986C91.6009 72.5183 82.1287 65.7219 77.4471 62.5L80.8779 48.3817L89.7833 51.5394L87.7429 58.9093L95.2519 63.9857C96.1802 64.5988 96.3074 64.6439 97.2874 64.7075L106.317 65.4954L111.009 55.0901L81.8757 44.7598L88.8745 18.5597Z",
    fill: "url(#paint0_linear_201_3362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.862 17.5522L140.215 27.251L114.68 83.5117L90.0977 81.7526L93.0274 73.4902C93.2556 73.5623 93.5272 73.5879 93.9847 73.6176L112.178 74.8151L123.465 49.8514L103.901 42.8238L106.869 34.4537L127.352 41.7165L130.857 33.4462L109.866 26.003L112.862 17.5522ZM100.832 51.4813L96.2028 64.5351C96.4889 64.6454 96.7687 64.6738 97.2874 64.7074L106.317 65.4954L111.009 55.0901L100.832 51.4813Z",
    fill: "url(#paint1_linear_201_3362)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "css-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628143 16.0273L70.1539 1.63388L78.2458 73.3465L51.9839 86.9831C51.961 86.9941 51.939 87.0047 51.918 87.0148C51.4806 87.2251 51.4502 87.2397 50.9265 87.202C50.7848 87.1918 50.2698 87.1501 49.4636 87.0847C44.6987 86.6987 29.7594 85.4883 21.5413 85.0857L0.628143 16.0273ZM16.6202 28.0228L60.5033 18.938L62.3718 27.2976L44.3593 39.4997L62.3355 35.7782L65.7551 62.9494L49.6843 71.8796C49.3149 72.0928 48.5218 72.257 48.0981 72.208L46.9864 72.1648L29.9112 70.9166L25.8729 57.403L34.4645 55.6244L36.6141 62.0125L45.2161 62.2816L46.1684 62.2211L47.0666 61.8985L56.0443 57.99L54.8228 46.7632L24.4218 53.0569L21.6281 44.8889L39.9015 31.9495L19.2817 36.2182L16.6202 28.0228Z",
    fill: "url(#paint2_linear_201_3362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9115 72.1421L50.6003 80.2997L73.0088 68.6908L65.8267 9.36279L37.144 15.3008L38.8261 23.4257L60.5033 18.938L62.3718 27.2976L44.3593 39.4997L62.3355 35.7782L65.7551 62.9494L49.6843 71.8796C49.4996 71.9862 49.2089 72.0805 48.9115 72.1421ZM46.81 61.9907L47.0666 61.8985L56.0443 57.99L54.8228 46.7632L44.1164 48.9797L46.81 61.9907Z",
    fill: "url(#paint3_linear_201_3362)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_3362",
    x1: 115.738,
    y1: 13.8862,
    x2: 64.2677,
    y2: 71.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_3362",
    x1: 128.54,
    y1: 52.5029,
    x2: 104.106,
    y2: 42.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_3362",
    x1: 35.391,
    y1: 8.83061,
    x2: 22.3859,
    y2: 85.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_3362",
    x1: 43.8722,
    y1: 47.8002,
    x2: 69.2862,
    y2: 40.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlcssLogo);
export default __webpack_public_path__ + "static/media/html&css-logo.81735b3f8c6f8c66c682c0d1a9235d48.svg";
export { ForwardRef as ReactComponent };